export const SMS_BIT = 0; // SMS
export const PUSH_BIT = 2; // PUSH
export const EMAIL_BIT = 1; // EMAIL
export const DEFAULT_CHANNEL = 5; // Push/SMS
export const DEFAULT_OVERRIDE_PREFERENCE = false;
